// extracted by mini-css-extract-plugin
export default {"control":"styles_control__U8+vB"};